module.exports = __webpack_public_path__ + "static/thoughts-on-digitization.eae5c52d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/presentations/thoughts-on-digitization.jpg
// module id = 202
// module chunks = 35783957827783 267625579013595